// ═══════════════════════════════════════════════════════════════
// API TSS - PLANILLAS DE SEGURIDAD SOCIAL
// ═══════════════════════════════════════════════════════════════

import api from './config';
import { downloadBlob } from './payrollReports';

export const getTSSPeriodos = async (companyId) => {
  const res = await api.get(`/tss/${companyId}/periodos`);
  return res.data;
};

export const getTSSPreview = async (companyId, periodo, tipo = 'AM') => {
  const res = await api.get(`/tss/${companyId}/preview/${periodo}`, { params: { tipo } });
  return res.data;
};

export const generarPlanillaTSS = async (companyId, periodo, forzar = false, tipo = 'AM') => {
  const [yyyy, mm] = periodo.split('-');
  const res = await api.post(
    `/tss/${companyId}/generar/${periodo}`,
    { forzar, tipo },
    { responseType: 'blob', params: { tipo } }
  );
  downloadBlob(res.data, `TSS_${tipo}_${mm}${yyyy}.txt`);
  return { planillaId: res.headers['x-planilla-id'] };
};

export const getTSSHistorial = async (companyId) => {
  const res = await api.get(`/tss/${companyId}/historial`);
  return res.data;
};

export const getTSSPlanillaRecords = async (planillaId) => {
  const res = await api.get(`/tss/planilla/${planillaId}/records`);
  return res.data;
};

export const downloadTSSPlanilla = async (planillaId, nombreArchivo) => {
  const res = await api.get(`/tss/planilla/${planillaId}/download`, { responseType: 'blob' });
  downloadBlob(res.data, nombreArchivo || `planilla_${planillaId}.txt`);
};

export const getTSSFormatos = async (companyId) => {
  const res = await api.get(`/tss/${companyId}/formatos`);
  return res.data;
};

export const updateTSSFormato = async (companyId, tipo, campos, version, descripcion) => {
  const res = await api.put(`/tss/${companyId}/formatos/${tipo}`, { campos, version, descripcion });
  return res.data;
};

// overrides = [{ employeeId, tipo_doc, clave_nomina, tipo_ingreso }]
// depOverrides = [{ dependentId, tipo_doc }]
export const saveTSSOverrides = async (companyId, overrides, depOverrides = []) => {
  const res = await api.put(`/tss/${companyId}/overrides`, { overrides, depOverrides });
  return res.data;
};
